import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {TechnicalApplicationModel} from './technical-application-model';
import {ListResponse} from './list-response';
import {TechnicalApplicationCategoryModel} from './technical-application-category-model';
import {AddTechnicalApplicationModel} from './add-technical-application-model';
import {UpdateTechnicalApplicationModel} from './update-technical-application-model';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TechnicalApplicationService {
  constructor(private httpClient: HttpClient) { }

  public getList(organizationId: string): Observable<ListResponse<TechnicalApplicationModel>> {
    return this.httpClient.get<ListResponse<TechnicalApplicationModel>>(
      `api/organizations/${organizationId}/technicalApplications`);
  }

  public getCategoryList(organizationId: string): Observable<ListResponse<TechnicalApplicationCategoryModel>> {
    return this.httpClient.get<ListResponse<TechnicalApplicationCategoryModel>>(
      `api/organizations/${organizationId}/technicalApplications/categories`);
  }

  public add(organizationId: string, request: AddTechnicalApplicationModel): Observable<TechnicalApplicationModel> {
    request.executorId = '...';
    return this.httpClient.post<TechnicalApplicationModel>(
      `api/organizations/${organizationId}/technicalApplications`,
      request);
  }

  public update(organizationId: string, itemId: string, request: UpdateTechnicalApplicationModel): Observable<TechnicalApplicationModel> {
    request.executorId = '...';
    return this.httpClient.put<TechnicalApplicationModel>(
      `api/organizations/${organizationId}/technicalApplications/${itemId}`,
      request);
  }

  getOne(organizationId: string, itemId: string): Observable<TechnicalApplicationModel> {
    return this.getList(organizationId).pipe(map(list => {
      return list.data.filter(x => x.id === itemId)[0];
    }));
  }
}
